import { cn } from "@/lib/utils";

// Placeholder pulito: blocco #17171A con nome prodotto centrato in #9A9AA3.
// Nessuna foto finta. Le immagini reali verranno caricate dal cliente.
export function ProductPlaceholder({
  label = "Prodotto",
  className = "",
  showLabel = true,
  size = "md",
  grid = false,
  ...rest
}) {
  const textSize = size === "lg" ? "text-sm sm:text-base" : size === "sm" ? "text-[10px]" : "text-xs";
  return (
    <div
      className={cn(
        "relative flex items-center justify-center overflow-hidden rounded-2xl bg-white/[0.02] text-steel",
        className
      )}
      data-testid="product-image-placeholder"
      {...rest}
    >
      {showLabel && (
        <span className={cn("relative max-w-[85%] px-4 text-center font-medium leading-relaxed line-clamp-2", textSize)}>
          {label}
        </span>
      )}
    </div>
  );
}
